// third-party
import {UserOutlined, FileDoneOutlined, WindowsOutlined, LineChartOutlined,GiftOutlined,IdcardOutlined} from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

// icons
const icons = {
    WindowsOutlined,
    UserOutlined,
    FileDoneOutlined,
    LineChartOutlined,
    GiftOutlined,
    IdcardOutlined
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const reports = {
    id: 'all-reports',
    title: <FormattedMessage id="all-reports" />,
    icon: icons.FileDoneOutlined,
    type: 'group',
    children: [
        {
            id: 'lids-reports',
            title: <FormattedMessage id="lids-reports" />,
            type: 'item',
            url: '/report-lids',
            icon: icons.UserOutlined
        },
        {
            id: 'pacient-reports',
            title: <FormattedMessage id="pacient-reports" />,
            type: 'collapse',
            icon: icons.UserOutlined,
            children: [
                {
                    id: 'pacient-reports',
                    title: <FormattedMessage id="all-stats" />,
                    type: 'item',
                    icon: icons.LineChartOutlined,
                    url: '/report-stats'
                },
                {
                    id: 'first-reports',
                    title: <FormattedMessage id="first-reports" />,
                    type: 'item',
                    icon: icons.LineChartOutlined,
                    url: '/report-pacient'
                },
                {
                    id: 'bonus',
                    title: <FormattedMessage id="bonus" />,
                    type: 'item',
                    icon: icons.GiftOutlined,
                    url: '/bonus'
                },{
                    id: 'bonus2',
                    title: <FormattedMessage id="bonus2" />,
                    type: 'item',
                    icon: icons.GiftOutlined,
                    url: '/bonus2'
                },{
                    id: 'bonus3',
                    title: <FormattedMessage id="bonus3" />,
                    type: 'item',
                    icon: icons.GiftOutlined,
                    url: '/bonus3'
                },{
                    id: 'extra-bonus',
                    title: <FormattedMessage id="extra-bonus" />,
                    type: 'item',
                    icon: icons.GiftOutlined,
                    url: '/extra-bonus'
                },{
                    id: 'checkin',
                    title: <FormattedMessage id="checkin" />,
                    type: 'item',
                    icon: icons.IdcardOutlined,
                    url: '/checkin'
                }
            ]
        }
    ]
};

export default reports;
